import React, { useState } from 'react';

const LogOfflineInteractionModal = () => {
  const [show, setShow] = useState(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
    <button className="btn btn-outline-secondary btn-sm font-500 rounded-pill" onClick={handleOpen}>📋 Log Offline Interaction</button>
      

      {show && (
        <>
          <div className="modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h6 className="modal-title fw-bold text-dark" id="logSessionModalLabel">📋 Log an Offline / External Session</h6>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <p className="small text-secondary mb-3">Record a session that happened outside the platform (e.g. phone call, in-person meeting).</p>

                  <div className="row g-3">
                    <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Mentee *</label>
                    <select className="form-select font-13">
                        <option>Arjun Mehta</option>
                        <option>Sneha Nair</option>
                        <option>Both (group session)</option>
                    </select>
                    </div>
                    <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Session Date *</label>
                    <input className="form-control font-13" type="date"/>
                    </div>
                    <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Duration</label>
                    <select className="form-select font-13">
                        <option>30 minutes</option>
                        <option selected>45 minutes</option>
                        <option>60 minutes</option>
                        <option>90 minutes</option>
                    </select>
                    </div>
                    <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Format</label>
                    <select className="form-select font-13">
                        <option>Video call</option>
                        <option>Phone call</option>
                        <option>In-person</option>
                        <option>WhatsApp / Chat</option>
                    </select>
                    </div>
                    <div className="col-12">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Topics Covered</label>
                    <div className="d-flex flex-wrap gap-2 mt-1">
                        <label className="form-check-label d-flex align-items-center gap-1 p-2 rounded border border-light-subtle font-12 cursor-pointer bg-light bg-opacity-25">
                        <input type="checkbox" className="form-check-input me-1"/> Career Direction
                        </label>
                        <label className="form-check-label d-flex align-items-center gap-1 p-2 rounded border border-light-subtle font-12 cursor-pointer bg-light bg-opacity-25">
                        <input type="checkbox" className="form-check-input me-1"/> Case Interview Prep
                        </label>
                        <label className="form-check-label d-flex align-items-center gap-1 p-2 rounded border border-light-subtle font-12 cursor-pointer bg-light bg-opacity-25">
                        <input type="checkbox" className="form-check-input me-1"/> Industry Insights
                        </label>
                        <label className="form-check-label d-flex align-items-center gap-1 p-2 rounded border border-light-subtle font-12 cursor-pointer bg-light bg-opacity-25">
                        <input type="checkbox" className="form-check-input me-1"/> Profile Review
                        </label>
                    </div>
                    </div>
                    <div className="col-12">
                    <label className="form-label small fw-bold text-secondary text-uppercase mb-1">Notes / Key Outcomes</label>
                    <textarea className="form-control h-auto font-13" rows={3} placeholder="What did you discuss? Any key takeaways or follow-ups agreed?"></textarea>
                    </div>
                </div>
                </div>

                <div className="modal-footer border-top-0 bg-light p-3 rounded-bottom-3 justify-content-end mt-3">
                    <button type="button" className="btn btn-sm btn-outline-secondary font-13" onClick={handleClose}>Cancel</button>
                    <button type="button" className="btn btn-sm btn-success text-white fw-bold px-3 font-13" >Log Session</button>
                </div>

                
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default LogOfflineInteractionModal;